/* eslint-disable react/default-props-match-prop-types */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import moment from 'moment'
import { format, toDate, startOfDay, subDays } from 'date-fns'
import constants from 'constants'
import DatePicker from 'react-toolbox/lib/date_picker'

import styles from './DateInput.scss'

class DateInput extends Component {
  shouldComponentUpdate(nextProps) {
    const {
      value, disabled, error, minDate,
    } = this.props
    return (value !== nextProps.value)
      || (disabled !== nextProps.disabled)
      || (error !== nextProps.error)
      || (minDate !== nextProps.minDate)
  }

  render() {
    const {
      className,
      disablePast,
      disabled,
      error,
      handleChange,
      label,
      minDate,
      name,
      note,
      valid,
      value,
    } = this.props

    const displayNote = (!valid) ? styles.isHidden : ''
    const _handleChange = (date) => {
      // handleChange(name, moment(date).format('YYYY-MM-DD'))
      handleChange(name, format(date, constants.DATE_FORMAT.STANDARD))
    }
    const date = (value.length) ? new Date(value) : value
    const optionalProps = {}

    // Set DatePicker minDate if necessary
    if (minDate) {
      // optionalProps.minDate = moment(minDate).toDate()
      optionalProps.minDate = toDate(minDate)
    } else if (disablePast) {
      // optionalProps.minDate = moment().subtract(1, 'days').toDate()
      optionalProps.minDate = startOfDay(subDays(new Date(), 1))
    }

    return (
      <div className={classnames(styles.input, className)}>
        <DatePicker
          autoOk
          error={error}
          inputClassName={styles.base}
          inputFormat={val => `${val.getDate()}/${val.getMonth() + 1}/${val.getFullYear()}`}
          label={label}
          onChange={_handleChange}
          readonly={disabled}
          theme={styles}
          value={date}
          {...optionalProps}
        />
        {(note) ? <span className={classnames(styles.note, displayNote)}>{note}</span> : null}
      </div>
    )
  }
}

DateInput.propTypes = {
  className: PropTypes.string,
  disablePast: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  minDate: PropTypes.string,
  name: PropTypes.string.isRequired,
  note: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string,
}

DateInput.defaultProps = {
  disablePast: true,
  disabled: false,
  error: '',
  text: '',
  valid: true,
}

export default DateInput



// WEBPACK FOOTER //
// ./src/components/Form/components/DateInput/DateInput.js